import SendInvitatesOrRemindersModal from './SendInvitatesOrRemindersModal.component';

export default SendInvitatesOrRemindersModal;
